import Entity from '../../utilities/entity';

class TrainingAttendance extends Entity {

}

export default new TrainingAttendance();